if (!customElements.get("side-panel-link")) {
  class SidePanelLink extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.setupObservers();
    }
    setupObservers() {
      this.addEventListener("click", () => {
        const id = this.dataset.id;
        const drawer = document.querySelector(id);
        if (drawer) {
          document.body.classList.add("open-cc");
          document.body.classList.add("side-panel-open");
          drawer.classList.add("active");
        }
      });
    }
  }

  customElements.define("side-panel-link", SidePanelLink);
}
